<template>
	<div class="thee-sixty-evaluation">
		<router-view></router-view>
	</div>
</template>

<script>
import {
	addFullSectionMargin,
	removeFullSectionMargin,
} from '../../shared/utils/handle-section-margin';

export default {
	name: 'page-three-sixty-evaluation',
	mounted() {
		addFullSectionMargin();
	},
	beforeDestroy() {
		removeFullSectionMargin();
	},
};
</script>

<style lang="scss">
.thee-sixty-evaluation {
	p,
	span {
		color: var(--app-color-font-gray);
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/pages/page-three-sixty-evaluation.vue